<template>
  <div class="head black">
  	<heade/>
  </div>
  <div class="services">
  		<our_services/>
  		<information_block/>
  </div>
  <div class="euclid">
  	<our_work/>
  	<box_success/>
  	<our_skill/>
  </div>
</template>


<script>
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import heade from '@/components/home_info.vue'
import our_services from '@/components/our_services.vue'
import information_block from '@/components/information_block.vue'
import our_work from '@/components/our_work.vue'
import box_success from '@/components/box_success.vue'
import our_skill from '@/components/our_skill.vue'

export default {
  name:'',
  components: {
  	heade,
  	our_services,
  	information_block,
  	our_work,
  	box_success,
  	our_skill
  },
  data(){
  	return{
  	}
  },
  mounted(){
  },
  created(){
  	
  },
  methods:{
  	...mapMutations({
	}),
	...mapActions({
	}),
  },
  computed:{
  	...mapGetters([
	]),
	}
};
</script>

<style scoped>
.euclid {
	position: relative;
	display:block;
}
.services {
background: url(../assets/img/back-desctop.svg);
background-repeat: no-repeat;
margin-top:0;
position: relative;
background-position-y: 150px;
}
/*.services:before {
	content:'';
	height:100%;
	width:100%;
	z-index: -1;
	background: linear-gradient(180deg, #2A1061 -0.03%, #1B0B3D 99.97%);
	transform: skewY(-3deg);
	display:block;
	position: absolute;
}*/
@media(max-width:1000px){
.services {
background: none;
background-size:contain;
background-repeat: no-repeat;
}
}	
</style>

